module.exports = __webpack_public_path__ + "static/media/drone.a268865e.svg";